import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/petitionGuides/category/details/pageContext';

export const PetitionGuidesCategoryErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Petition Guides Category page (error: ${error})`);
};
